<script>
import { LandingContentBlock } from '@rei/landing-content-block';
import UgcGallery from '@rei/ugc-gallery';

import '@rei/ugc-gallery/src/style/rei-spinner.scss';

export default {
  name: 'UgcPlacementComponent',
  components: {
    LandingContentBlock,
    UgcGallery,
  },
  props: {
    content: { type: Object, default: () => ({}) },
    items: { type: Array, default: () => ([]) },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    hasMoreItems: { type: Boolean, default: false },
    config: { type: Object, default: () => ({}) },
  },
};
</script>

<template>
  <div class="ugc-placement">
    <landing-content-block
      class="ugc-placement__content-block"
      v-bind="content"
    />
    <ugc-gallery
      :items="items"
      :loading="loading"
      :error="error"
      :has-more-to-load="hasMoreItems"
      :config="config"
      @onLoadMore="$emit('onLoadMore')"
    />
  </div>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.ugc-placement {
  &__content-block {
    margin-bottom: $cdr-space-one-and-a-half-x;
  }
}
</style>
